import { type GuardArgs } from 'xstate/guards';

import { type Context, type Event } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

const checkIfReachedTarget: Guard = ({ context }) => {
  const { programmaticTargetY, scrollOffset, scrollViewDimensions } = context;

  if (programmaticTargetY === null) return true;

  const { contentHeight, viewportHeight } = scrollViewDimensions;

  const scrollY = scrollOffset.value;
  const maxScrollY = contentHeight - viewportHeight;

  const hasReachedTarget = Math.abs(scrollY - programmaticTargetY) < PROGRAMMATIC_SCROLL_THRESHOLD;
  const hasReachedEnd = programmaticTargetY > maxScrollY && scrollY >= maxScrollY - PROGRAMMATIC_SCROLL_THRESHOLD; // prettier-ignore

  return hasReachedTarget || hasReachedEnd;
};

// ─────────────────────────────────────────────────────────────────────────────

const checkIfHasMeasurements: Guard = ({ context }) => {
  return Object.keys(context.measurements).length > 0;
};

export const Guards = {
  checkIfReachedTarget,
  checkIfHasMeasurements,
};

// ─── Constants ───────────────────────────────────────────────────────────────

const PROGRAMMATIC_SCROLL_THRESHOLD = 2;

// ─── Types ───────────────────────────────────────────────────────────────────

type Guard = (args: GuardArgs<Context, Event>) => boolean;
